module.exports = __webpack_public_path__ + "img/65-green.d5cfcb2d.svg";